import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CommonModule } from '@angular/common';
import { CareersComponent } from './careers/careers.component';
import { InternshipComponent } from './internship/internship.component';
import * as AOS from 'aos';
import Swiper from 'swiper'; 
import { register } from 'swiper/element';
import { ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CareersRoutingModule } from './careers-routing.module';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';

register();

@NgModule({ declarations: [
        CareersComponent,
        InternshipComponent
    ], schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        // SlickCarouselModule,
        ReactiveFormsModule,
        CareersRoutingModule, SharedModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class CareersModule { }
